var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecordings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,17.69h0a2.32,2.32,0,0,1-2.3,2.3H13.46v2h4.23A4.3,4.3,0,0,0,22,17.69V13.47H20Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.73,3.26a4.31,4.31,0,0,0-3-1.26H13.46V4h4.23A2.32,2.32,0,0,1,20,6.3v4.23h2V6.3A4.31,4.31,0,0,0,20.73,3.26Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4,6.3H4A2.32,2.32,0,0,1,6.29,4h4.23V2H6.29A4.3,4.3,0,0,0,2,6.3v4.23H4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29,20a2.3,2.3,0,0,1-2.12-1.41A2.25,2.25,0,0,1,4,17.7V13.47H2v4.22a4.17,4.17,0,0,0,.34,1.68,4.3,4.3,0,0,0,4,2.63h4.23V20Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17,12a5,5,0,1,0-5,5A5,5,0,0,0,17,12Zm-5,3a3,3,0,1,1,3-3A3,3,0,0,1,12,15Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordings);
export default __webpack_public_path__ + "static/media/recordings.f8adaf2160a9c4ad3a1019f94bc6a543.svg";
export { ForwardRef as ReactComponent };